module.exports = __webpack_public_path__ + "public/SiteIcons/searchIconHome.svg?19c3c030";